import { getPurchaseHistory } from "@/http/purchaseHistoryApi";
import { getPurchaseHistoryQueryKey } from "@/utils/queryKeys";
import { useQuery } from "@tanstack/react-query";

export const useGetPurchaseHistoryQuery = () => {
  return useQuery({
    queryKey: getPurchaseHistoryQueryKey(),
    queryFn: () => getPurchaseHistory(),
    select: (response) => response.data.data,
  });
};
